import { Component, Vue } from "vue-property-decorator"
import { AgreementData } from '@/types/views/agreement.interface'
// import {  } from "@/components" // 组件
import app from '@/api/app'

@Component({})
export default class Agreement extends Vue {

  // data
  private pageName = 'agreement'
  private flag: boolean = false
  private flag2: boolean = false
  private code: any

  created() {
    this.code = this.$route.query.code;
  }

  mounted() {
    //
    if (this.code == "0") {
      this.flag = true
      this.flag2 = false
    }

    if (this.code == "1") {
      this.flag2 = true
      this.flag = false
    }
  }

  // 初始化函数
  init() {
    //
  }

  show() {
    this.flag = !this.flag
  }

  show2() {
    this.flag2 = !this.flag2
  }

  // 返回app
  goBack() {
    app.goBack();
  }

}
